// shared.js
import { reactive } from 'vue'

export const shared = reactive({
  allow_control: true,
  show_host_devices: true,

  firmware_versions: {},

  get_nested_value_safely(obj, full_key, round = null, multiplier = null) {
    var parts = full_key.split(".")
    var sub_obj = obj

    if (sub_obj == null){
        return "-"
    }

    for (const part in parts) {
        sub_obj = sub_obj[parts[part]]
        if (sub_obj == null){
            return "-"
        }   
    }

    if (round != null) {
        if (multiplier != null) {
          return (parseFloat(sub_obj) * multiplier).toFixed(round)
        } else {
          return parseFloat(sub_obj).toFixed(round)
        }
    } else {
        return sub_obj
    }
  },
  get_descriptive_safely(obj, key) {
    if (obj == null || obj.descriptive == null) {
        return this.get_nested_value_safely(obj, key + "*")
    } else {
        return obj.descriptive[key]
    }
  },
  check_minimum_protocol_version(info, major, minor) {
    if (info == null || info.protocol_version == null) {
      return false
    }
    let protocol_version_array = info.protocol_version.replace("v-","").split(".")
    let version_minimum = (major << 24) | (minor << 16);
    let version_protocol = (protocol_version_array[0] << 24) | (protocol_version_array[1] << 16);
    if (version_protocol <= version_minimum) {
      return true;
    } else {
      return false;
    }
  },
  check_device_online(device) {
    return device != null && device.status == 'online' && (device.data != null || device.data_quick != null)
  },
  check_any_live_data(device) {
    return device != null && (device.data != null || device.data_quick != null)
  },
  check_any_device_updating(deviceDetail) {
    return deviceDetail != null && deviceDetail.status == 'updating'
  }
})